import { storyblokEditable } from "gatsby-source-storyblok"
import React, { useMemo } from "react"

import ComparisonTableSection from "../../../V2/Layouts/ComparisonTableSection"

import { getUrlFromStoryblokLink, linkIsNotNull } from "@utils/storyblok"

const StoryblokComparisonTableSection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ComparisonTableSection>) => {
  const tableColumnImages = useMemo(() => {
    const firstRowIsImages = !!blok.data.thead.find((cell) =>
      cell.value.match(/:image\((.*?)\):/)
    )
    if (firstRowIsImages) {
      const tempImages = [] as string[]
      blok.data.thead.forEach((cell, index) => {
        if (!(index === 0 && cell.value === "")) {
          tempImages.push(cell.value)
        }
      })
      return tempImages
    }
    return undefined
  }, [blok.data.thead])

  const tableRowHeadings = useMemo(() => {
    const tempRowHeadings = []
    if (!tableColumnImages) {
      tempRowHeadings.push(blok.data.thead[0].value)
    }
    blok.data.tbody.forEach((row) => {
      tempRowHeadings.push(row.body[0].value)
    })

    return tempRowHeadings
  }, [tableColumnImages, blok.data.thead, blok.data.tbody])

  const tableData = useMemo(() => {
    const tempTableData = [] as string[][]
    if (!tableColumnImages) {
      const tempRow = [] as string[]
      blok.data.thead.forEach((cell, index) => {
        if (index !== 0) {
          tempRow.push(cell.value)
        }
      })
      tempTableData.push(tempRow)
    }
    blok.data.tbody.forEach((row) => {
      const tempRow = [] as string[]
      row.body.forEach((cell, index) => {
        if (index !== 0) {
          tempRow.push(cell.value)
        }
      })
      tempTableData.push(tempRow)
    })

    return tempTableData
  }, [tableColumnImages, blok.data.thead, blok.data.tbody])

  return (
    <ComparisonTableSection
      sectionId={blok._uid}
      headingSize={blok.headingSize}
      headingSecondaryText={blok.headingSecondaryText}
      overrideHeadingSecondaryColor={blok.overrideHeadingSecondaryColor}
      headingPrimaryText={blok.headingPrimaryText}
      overrideHeadingPrimaryColor={blok.overrideHeadingPrimaryColor}
      backgroundColor={blok.backgroundColor}
      tableNumDesktopColumns={blok.tableNumDesktopColumns}
      tableColumnImages={tableColumnImages}
      tableRowHeadings={tableRowHeadings}
      tableData={tableData}
      disclaimerText={blok.disclaimerText}
      buttonBorderColor={blok.ctaBorderColor}
      buttonText={blok.ctaText}
      buttonLink={
        linkIsNotNull(blok.ctaLink) ? getUrlFromStoryblokLink(blok.ctaLink) : ""
      }
      variant={blok.variant}
      outerContainer={blok.outerContainer}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokComparisonTableSection
